export default __webpack_public_path__ + "static/media/vogliadipizza_pizza.47b32444.png";